import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQSection from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';
function Tempotravelleronrentinpunne() {



    const cardData =
    {
        keyword: ' Tempo Traveller on Rent in Pune',
        heading: 'Samarth Travels: Tempo Traveller on Rent in Pune',
        headingDescription: 'Samarth Travels offers Tempo Traveller on rent in Pune for comfortable and convenient group travel. Ideal for family trips, corporate tours, and weekend getaways, our fleet includes 12 to 17-seater air-conditioned Tempo Travellers. With experienced drivers, transparent pricing, and no hidden charges, Samarth Travels ensures a smooth and reliable travel experience every time.',

        top: 'Top Places to Visit in Pune with Samarth Travels',

        "topPlaces": [
             {
                "title": "Sinhagad Fort",
                "description": "Perched atop the Sahyadri hills, Sinhagad Fort is a historic hill fortress located about 30 kilometers from Pune. Famous for the Battle of Sinhagad in 1670, where Maratha warrior Tanaji Malusare fought valiantly, the fort offers breathtaking views, trekking trails, and remnants of ancient military architecture including bastions, gates, and memorials. It's an ideal destination for trekking enthusiasts, history buffs, and nature lovers alike."
            }, 
            {
                "title": "Shaniwar Wada",
                "description": "Shaniwar Wada is one of Pune's most iconic landmarks and a symbol of the Maratha Empire. Built in 1732 as the seat of the Peshwas, this grand fortification features majestic gates, elegant fountains, and intricate architecture. Although much of it was destroyed by fire in 1828, its massive stone walls and legendary tales—especially those surrounding the ghost of Narayanrao—still attract thousands of history lovers and tourists each year."
            },
            {
                "title": "Aga Khan Palace",
                "description": "The Aga Khan Palace is a stunning historical monument built in 1892 by Sultan Aga Khan III. It holds immense national significance due to its association with Mahatma Gandhi, Kasturba Gandhi, and other freedom fighters who were imprisoned here during the Quit India Movement. Set in lush green gardens, the palace showcases Italian arches and spacious halls and also houses a museum with photographs, paintings, and personal belongings of Gandhi, making it a must-visit for those interested in India’s independence movement."
            },
            {
                "title": "Pataleshwar Cave Temple",
                "description": "The Pataleshwar Cave Temple is a unique 8th-century rock-cut shrine dedicated to Lord Shiva. Carved from a single massive basalt rock, this ancient temple is a fine example of monolithic architecture from the Rashtrakuta period. Its main sanctum houses a linga, and the surrounding sanctum sanctorum includes statues of other deities. Despite being in the middle of the bustling city, it offers a tranquil and spiritual atmosphere for visitors."
            }, 
            {
                "title": "Dagdusheth Halwai Ganpati Temple",
                "description": "This revered Ganesh temple is one of the most visited and richly adorned temples in Maharashtra. Established by a sweet-maker named Dagdusheth Halwai in the late 19th century, the temple is known for its magnificent idol of Lord Ganesh decked in gold and diamonds. The temple draws massive crowds during the Ganesh Chaturthi festival, and its serene ambiance makes it a spiritual haven throughout the year."
            },
            {
                "title": "Raja Dinkar Kelkar Museum",
                "description": "This museum is a treasure trove of Indian heritage and folk art, established by Dr. Dinkar Kelkar in memory of his son. It houses over 20,000 rare and artistic artifacts, including musical instruments, sculptures, paintings, utensils, weaponry, and textiles from all over India. The collection gives a vivid picture of everyday life in bygone eras and is especially appealing to art enthusiasts and cultural historians."
            },
            {
                "title": "Parvati Hill and Temple",
                "description": "Rising 2,100 feet above sea level, Parvati Hill offers panoramic views of Pune city. The hilltop temple complex consists of five main temples, including the Devdeveshwar temple dedicated to Lord Shiva and Goddess Parvati. Built during the Peshwa rule, it is not only a religious site but also a peaceful escape from the city buzz. A climb of 103 stone steps leads to the summit, where history and nature meet."
            },
            {
                "title": "Osho Ashram",
                "description": "Located in the serene Koregaon Park area, the Osho International Meditation Resort is a tranquil oasis for seekers of inner peace and mindfulness. Founded by the spiritual guru Osho, it offers daily meditation sessions, yoga programs, and various wellness therapies in a luxurious, Zen-like environment. Visitors from all over the world come here for spiritual growth, rejuvenation, and to experience the calm ambiance of its lush gardens and modern facilities."
            },
            {
                "title": "Pune Okayama Friendship Garden",
                "description": "Also known as Pu La Deshpande Garden, this beautifully landscaped garden is inspired by Japan’s Okayama Korakuen Garden. Spread over 10 acres, it features artistically arranged lawns, water bodies, bridges, and pathways that create a harmonious blend of nature and design. It's a favorite among photography enthusiasts, families, and couples seeking a peaceful retreat amid nature."
            },
            {
                "title": "Katraj Snake Park and Rajiv Gandhi Zoological Park",
                "description": "This combined facility includes a zoo, snake park, and a wildlife rescue center. The snake park is known for its wide variety of snakes, including the King Cobra and Indian Python, as well as informative exhibits on reptile behavior and conservation. The adjoining zoo is home to tigers, leopards, elephants, and other animals, making it an engaging educational and recreational spot, especially for children and families."
            }
        ],

"services": [
    {
        "name": "Tempo Traveller Rental Services in Pune",
        "description": "Samarth Travels offers reliable Tempo Traveller rental services in Pune for all your travel needs. Whether it’s a family trip, corporate outing, or group travel, our fleet of well-maintained vehicles ensures comfort, punctuality, and a hassle-free experience."
    },
    {
        "name": "Affordable Tempo Traveller Rent in Pune",
        "description": "Looking for an affordable Tempo Traveller for your trip? Samarth Travels provides budget-friendly rental options in Pune without compromising on comfort or service. Perfect for group tours, family vacations, or corporate events, we offer the best value for your travel needs."
    },
    {
        "name": "Hire Tempo Traveller with Driver in Pune",
        "description": "Rent a Tempo Traveller with a professional driver from Samarth Travels in Pune. Our experienced drivers ensure a safe, smooth, and pleasant journey, allowing you to focus on enjoying the trip. Available for all types of local and outstation travel."
    },
    {
        "name": "Rent 16-Seater Tempo Traveller in Pune",
        "description": "For larger groups, Samarth Travels offers a 16-seater Tempo Traveller for rent in Pune. Ideal for family outings, corporate tours, or group trips, our spacious and air-conditioned vehicles guarantee a comfortable and enjoyable ride."
    },
    {
        "name": "Tempo Traveller Hire for Family Trips in Pune",
        "description": "Make your family trips comfortable and memorable with a Tempo Traveller hire from Samarth Travels. With ample seating, AC comfort, and enough space for luggage, our vehicles are perfect for family vacations, local tours, and get-togethers in and around Pune."
    },
    {
        "name": "Rent a 12-Seater Tempo Traveller in Pune",
        "description": "Rent a 12-seater Tempo Traveller from Samarth Travels in Pune for small group trips or family get-togethers. Our well-maintained vehicles are perfect for sightseeing tours, picnics, and other group activities, offering comfort and reliability throughout the journey."
    },
    {
        "name": "Luxury Tempo Traveller Hire in Pune",
        "description": "Travel in style and comfort with a luxury Tempo Traveller hire from Samarth Travels in Pune. Our premium fleet is equipped with plush interiors, AC, and additional amenities for corporate events, weddings, or high-end leisure trips."
    },
    {
        "name": "AC Tempo Traveller for Rent in Pune",
        "description": "Rent an AC Tempo Traveller from Samarth Travels for a cool, comfortable journey in Pune and beyond. Whether it’s a sightseeing tour, corporate outing, or family trip, our air-conditioned vehicles provide the perfect solution for all your travel needs."
    },
    {
        "name": "Budget Tempo Traveller Rent for Group Travel in Pune",
        "description": "Looking for a budget-friendly option for group travel? Samarth Travels offers affordable Tempo Traveller rentals in Pune that don’t compromise on comfort or quality. Perfect for friends, families, or corporate groups looking for cost-effective transportation."
    },
    {
        "name": "Rent Tempo Traveller for Corporate Events in Pune",
        "description": "For your next corporate event or team outing, rent a Tempo Traveller from Samarth Travels. Our well-equipped vehicles provide the perfect solution for transporting employees, clients, or guests to business meetings, offsites, and corporate events in Pune."
    }
],
"tableData": [
    ["Tempo Traveller Rental Services in Pune", "Affordable Tempo Traveller Rent in Pune"],
    ["Hire Tempo Traveller with Driver in Pune", "Rent 16-Seater Tempo Traveller in Pune"],
    ["Tempo Traveller Hire for Family Trips in Pune", "Rent a 12-Seater Tempo Traveller in Pune"],
    ["Luxury Tempo Traveller Hire in Pune", "AC Tempo Traveller for Rent in Pune"],
    ["Budget Tempo Traveller Rent for Group Travel in Pune", "Rent Tempo Traveller for Corporate Events in Pune"]
],


"whychoose": [
    {
        "WhyChooseheading": "Reliable Tempo Traveller on Rent in Pune",
        "WhyChoosedescription": "Samarth Travels offers dependable and efficient Tempo Traveller rental services in Pune for group travel. Whether you're organizing a family trip, corporate outing, or a group tour, our fleet of well-maintained Tempo Travellers ensures a safe, comfortable, and on-time journey for your group, no matter the size or destination."
    },
    {
        "WhyChooseheading": "Comfortable and Spacious Tempo Travellers for Group Travel",
        "WhyChoosedescription": "Our fleet of Tempo Travellers includes various sizes to cater to groups ranging from 9 to 26 passengers. Each vehicle is equipped with air-conditioning, plush seats, ample legroom, and large windows for scenic views, providing a comfortable and relaxing environment during your travels across Pune or beyond."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers for Your Safety",
        "WhyChoosedescription": "At Samarth Travels, we prioritize safety. Our professional drivers are experienced, courteous, and familiar with Pune's roadways, ensuring smooth travel and timely arrivals. Whether you're navigating busy city roads or exploring scenic routes, our drivers will ensure your journey is both safe and pleasant."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing for Tempo Traveller Rentals",
        "WhyChoosedescription": "We offer competitive and transparent pricing for Tempo Traveller rentals in Pune. With no hidden charges, you can trust us for affordable rates that give you the best value for your money. Whether you're renting for a day, weekend, or longer, our pricing is straightforward and ensures no surprises along the way."
    },
    {
        "WhyChooseheading": "Flexible 24/7 Availability for All Your Travel Needs",
        "WhyChoosedescription": "Samarth Travels offers flexible 24/7 availability for Tempo Traveller on Rent in Pune, accommodating early departures, late-night returns, and last-minute bookings. Our round-the-clock service ensures that you have reliable transportation whenever you need it, no matter your travel schedule."
    },
    {
        "WhyChooseheading": "Easy Online Booking and Real-Time Tracking",
        "WhyChoosedescription": "Booking your Tempo Traveller is quick and simple with Samarth Travels. You can easily make a reservation through our website or contact our customer service team. Once your booking is confirmed, you’ll receive real-time updates, including live tracking, driver contact information, and estimated arrival times, ensuring a hassle-free experience."
    },
    {
        "WhyChooseheading": "Clean, Sanitized, and Well-Maintained Tempo Travellers",
        "WhyChoosedescription": "We take cleanliness seriously. All our Tempo Travellers are thoroughly sanitized before and after every trip, ensuring a safe and hygienic environment for your group. Additionally, each vehicle is well-maintained, regularly checked for safety and comfort, and equipped with necessary amenities for a smooth and enjoyable journey."
    },
    {
        "WhyChooseheading": "Multiple Payment Options for Convenient Transactions",
        "WhyChoosedescription": "Samarth Travels offers a variety of secure payment options for your Tempo Traveller rental, including cash, UPI, credit/debit cards, and digital wallets. This flexibility ensures that you can choose the payment method that works best for you, making your booking process smooth and convenient."
    }
]















    }

const faqData = [
    {
        id: 1,
        question: 'How do I book a Tempo Traveller on rent in Pune with Samarth Travels?',
        answer: 'Booking a Tempo Traveller on rent in Pune with Samarth Travels is easy. You can contact us through our website or call our customer support. Provide your travel details like destination, group size, and travel date, and we’ll arrange the perfect vehicle for your trip.',
    },
    {
        id: 2,
        question: 'What seating options are available for Tempo Traveller rentals in Pune?',
        answer: 'We offer various Tempo Traveller seating options including 9-seater, 12-seater, 17-seater, and 20-seater vehicles. All are well-maintained and ideal for family trips, group tours, and corporate travel.',
    },
    {
        id: 3,
        question: 'Are the Tempo Travellers air-conditioned and comfortable?',
        answer: 'Yes, all our Tempo Travellers are air-conditioned and equipped with pushback seats, ample luggage space, and clean interiors to ensure a comfortable journey for all passengers.',
    },
    {
        id: 4,
        question: 'Can I rent a Tempo Traveller for outstation trips from Pune?',
        answer: 'Absolutely. We provide Tempo Travellers for both local and outstation travel from Pune to popular destinations like Lonavala, Mahabaleshwar, Shirdi, Goa, and more.',
    },
    {
        id: 5,
        question: 'Is one-day Tempo Traveller rental available in Pune?',
        answer: 'Yes, we offer flexible rental options including one-day rentals for city tours, weddings, airport transfers, and short group trips. Our packages are tailored to suit your schedule and budget.',
    },
    {
        id: 6,
        question: 'What is included in the rental cost?',
        answer: 'Our Tempo Traveller rental charges include vehicle rent, driver, and fuel. Additional costs like tolls and parking will be informed upfront. We ensure complete price transparency with no hidden charges.',
    },
    {
        id: 7,
        question: 'Do you offer 24/7 service for Tempo Traveller rentals in Pune?',
        answer: 'Yes, Samarth Travels provides 24/7 service. Whether your journey starts early in the morning or late at night, our team is ready to assist with timely and reliable travel arrangements.',
    },
];

const testimonials = [
    {
        name: 'Mr. Amit Deshmukh',
        role: 'IT Professional',
        text: 'We booked a 12-seater Tempo Traveller from Samarth Travels for a weekend trip to Mahabaleshwar. The vehicle was clean and comfortable, and the driver was polite and punctual. Great experience!',
        image: '/img/testimonial/testi_2_34.jpg',
    },
    {
        name: 'Mrs. Priyanka Bhave',
        role: 'Homemaker',
        text: 'I rented a Tempo Traveller for a family wedding in Pune. Everything went smoothly—from booking to the journey. The AC was great, and the service was professional. Highly recommended!',
        image: '/img/testimonial/testi_2_35.jpg',
    },
];






















    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9860256019",
            "+91 9527500025",

        ],
        email: "samarthtravels9119@gmail.com"
    };


   const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: " Tempo Traveller Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Tempo Traveller on Rent Pune",
        },
        {
            place: "/images/keyword/3.jpg",
            text: " Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: " Tempo Traveller on Rent",
        },
        {
            place: "/images/keyword/5.jpg",
            text: " Tempo Traveller Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: " Tempo Traveller Hire in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: " Mini Bus for Rent",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Bus on Rent Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: " Bus on Rent Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: " Bus Rental in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: " Hire Tempo Traveller",
        },
        {
            place: "/images/keyword/12.jpg",
            text: " Bus Hire in Pune",
        },
        {
            place: "/images/keyword/13.jpg",
            text: " Ac Tempo Traveller Rent Pune",
        },
        {
            place: "/images/keyword/14.jpg",
            text: " Bus Hire For Outstation",
        },
        {
            place: "/images/keyword/15.jpg",
            text: " Bus on Rent for Local",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Bus Rental For Wedding",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Bus Rent for Marriage",
        },
        {
            place: "/images/keyword/18.jpg",
            text: " Bus Rental For Corporate Events",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "  Bus Rental for Tour",
        },

        {
            place: "/images/keyword/20.jpg",
            text: "Bus Rental For Corporate in Pune",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/22.jpg",
            text: " AC Bus On Rent",
        },
        {
            place: "/images/keyword/23.jpg",
            text: " Non Ac Bus Rental Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Bus on Hire on Pune to Mahabaleshwar Package Tour ",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Bus Hire for Picnic",
        },
    ];


    const images = [
        { src: "/images/fleets/1.jpg", alt: "Image 1" },
        { src: "/images/fleets/2.jpg", alt: "Image 1" },
        { src: "/images/fleets/3.jpg", alt: "Image 1" },
        { src: "/images/fleets/4.jpg", alt: "Image 1" },
        { src: "/images/fleets/5.jpg", alt: "Image 1" },
        { src: "/images/fleets/6.jpg", alt: "Image 1" },
        { src: "/images/fleets/7.jpg", alt: "Image 1" },
        { src: "/images/fleets/8.jpg", alt: "Image 1" },
        { src: "/images/fleets/9.jpg", alt: "Image 1" },


    ];





// const productSchema = {
//   "@context": "https://schema.org",
//   "@type": "Product",
//   "name": "Tempo Traveller on Rent in Pune",
//   "image": "https://samarthtravels.com/assets/images/tempo-traveller-on-rent-pune.jpg",
//   "description": "Affordable and luxury Tempo Traveller rental services in Pune, including options for family trips, corporate events, weddings, and more. Hire AC and 16-seater Tempo Travellers with a driver for group sightseeing and travel.",
//   "brand": {
//     "@type": "Brand",
//     "name": "Samarth Travels"
//   },
//   "aggregateRating": {
//     "@type": "AggregateRating",
//     "bestRating": "5",
//     "worstRating": "1",
//     "ratingValue": "4.8",
//     "ratingCount": "5471"
//   },
//   "offers": {
//     "@type": "Offer",
//     "priceCurrency": "INR",
//     "price": "3200",
//     "availability": "https://schema.org/InStock",
//     "url": "https://samarthtravels.com/tempo-traveller-on-rent-pune"
//   }
// };

  const productSchema = {
    "@context": "https://schema.org",
    "@type": "Product",
    "name": "Tempo Traveller on Rent in Pune",
    "image": "https://samarthtravels.com/assets/images/tempo-traveller-on-rent-pune.jpg",
    "description": "Affordable and luxury Tempo Traveller rental services in Pune, including options for family trips, corporate events, weddings, and more. Hire AC and 16-seater Tempo Travellers with a driver for group sightseeing and travel.",
    "brand": {
      "@type": "Brand",
      "name": "Samarth Travels"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "bestRating": "5",
      "worstRating": "1",
      "ratingValue": "4.8",
      "ratingCount": "5471"
    },
    "offers": {
      "@type": "Offer",
      "priceCurrency": "INR",
      "price": "3200",
      "availability": "https://schema.org/InStock",
      "url": "https://samarthtravels.com/tempo-traveller-on-rent-pune"
    }
  };

  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "Samarth Travels",
    "image": "https://samarthtravels.com/assets/images/logo.png",
    "url": "https://samarthtravels.com",
    "telephone": "+91-XXXXXXXXXX",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Your Office Address Here",
      "addressLocality": "Pune",
      "addressRegion": "MH",
      "postalCode": "411001",
      "addressCountry": "IN"
    },
    "openingHours": "Mo-Su 08:00-20:00",
    "sameAs": [
      "https://www.facebook.com/YourPage",
      "https://www.instagram.com/YourPage"
    ]
  };



    return (
        <div>

  <Helmet>
      <title>Tempo Traveller on Rent in Pune – AC, 12/16 Seater | Samarth Travels</title>
      <meta 
        name="description" 
        content="Book AC Tempo Traveller on rent in Pune with driver. 12, 16, 20-seaters for group tours, weddings, and outstation trips. Rated 4.8★ – Call now for best price!" 
      />
      <meta 
        name="keywords" 
        content="Tempo Traveller on Rent in Pune, AC Tempo Traveller Hire Pune, 16-Seater Tempo Traveller Pune, 12-Seater Tempo Traveller with Driver Pune, Luxury Tempo Traveller Rent in Pune, Group Tour Vehicle Hire Pune, Wedding Tempo Traveller in Pune, Pune to Shirdi Tempo Traveller, Tempo Traveller for Outstation Pune" 
      />
      <link rel="canonical" href="https://samarthtravels.com/tempo-traveller-on-rent-pune" />
      <meta name="robots" content="index, follow" />
      <script type="application/ld+json">{JSON.stringify(productSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(localBusinessSchema)}</script>
    </Helmet>

{/* <Helmet>
  <title>Tempo Traveller on Rent in Pune | AC, Luxury & 16-Seater | Samarth Travels</title>
  <meta 
    name="description" 
    content="Hire AC and luxury Tempo Traveller on rent in Pune for sightseeing, family trips, corporate events, and weddings. Options include 12-seater, 16-seater, and more with affordable pricing and professional driver services." 
  />
  <meta 
    name="keywords" 
    content="Tempo Traveller Rental Services in Pune, Affordable Tempo Traveller Rent in Pune, Hire Tempo Traveller with Driver in Pune, Rent 16-Seater Tempo Traveller in Pune, Tempo Traveller Hire for Family Trips in Pune, Rent a 12-Seater Tempo Traveller in Pune, Luxury Tempo Traveller Hire in Pune, AC Tempo Traveller for Rent in Pune, Budget Tempo Traveller Rent for Group Travel in Pune, Rent Tempo Traveller for Corporate Events in Pune" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet> */}

            <div className="breadcumb-wrapper" data-bg-src="/images/breadcumb-bg.jpg">
                <div className="container">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title text-center">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>



            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/21.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Samarth Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQSection faqs={faqData} accordionId="drivingAccordion" />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword
                                data={testimonials}
                                title="What Our Clients Are Saying"
                                subtitle="Customer Feedback"
                            />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #FF8F1F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#FF8F1F' }}>
                                            <h4 className=" lead fw-semibold whitt textt-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919860256019" className="d-block  text-white">+91 9860256019</a>
                                                <a href="tel:+919527500025" className="d-block  text-white">+91 9527500025</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#FF8F1F' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Email</h4>
                                                <a href="mailto:samarthtravels9119@gmail.com" className=" text-white d-block">
                                                    samarthtravels9119@gmail.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#FF8F1F' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Samarth Travels <br />
                                                        Flat no 201, Juhi Building, Suyash Shrushti Society, Tukai darshan Hadapsar, Pune- 411028
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Tempotravelleronrentinpunne;